import React from 'react';
import { Box, Typography } from '@mui/material';
import { SEARCE_COLORS } from '../../theme';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actionButton?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, actionButton }) => (
  <Box
    sx={{
      backgroundColor: SEARCE_COLORS.white,
      borderBottom: `1px solid ${SEARCE_COLORS.neutral_200}`,
      px: 4,
      py: 1.5,
      position: 'sticky',
      top: 0,
      zIndex: 1200,
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
      mx: { xs: -2, sm: -3, md: -4 },
      mb: 3,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    }}
  >
    <Box sx={{ flex: 1, minWidth: 0, pr: { xs: 1, sm: 2 } }}>
      <Typography
        variant="h4"
        component="h1"
        sx={{
          fontWeight: 700,
          color: SEARCE_COLORS.textPrimary,
          fontSize: { xs: '1.3rem', sm: '1.5rem', md: '1.75rem' },
          letterSpacing: '-0.02em',
          lineHeight: 1.2,
          background: `linear-gradient(135deg, ${SEARCE_COLORS.primary} 0%, ${SEARCE_COLORS.secondary} 100%)`,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          mb: subtitle ? 0.5 : 0,
        }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="body2"
          component="div"
          sx={{
            color: SEARCE_COLORS.textSecondary,
            fontWeight: 350,
            fontSize: '0.875rem',
            whiteSpace: 'normal',
            overflowWrap: 'break-word',
            wordBreak: 'break-word',
            maxWidth: '100%',
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
    {actionButton && (
      <Box sx={{ flexShrink: 0, alignSelf: 'flex-start', pt: 0.25 }}>
        {actionButton}
      </Box>
    )}
  </Box>
);
